import React from 'react'
import { MDBTable, MDBTableBody, MDBTableHead } from 'mdbreact';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTrashAlt, faEdit } from '@fortawesome/free-solid-svg-icons'
import Avatar from '../../../paginas/img/avatar.jpg'
import HeaderTabla from '../../componentes/HeaderTabla'
import BotonesFormulario from '../../componentes/BotonesFormulario'
import moment from 'moment'

const VerEstados = ({ data, seleccionaRegistro }) => {


	return (
		<div>
			<MDBTable hover responsive>
				<HeaderTabla array={['Id', 'Estado', 'Tipo', '']} />
				<MDBTableBody>

					{data.map((item, index) => {
						return (
							<tr key={index}>
								<td>{item.id}</td>
								<td><div className={`estados`} style={{backgroundColor: item.color}}>{item.nombre}</div></td>
								<td>CRM</td>
								<td className="tabla_funciones">
									<BotonesFormulario SeleccionarCategoria={seleccionaRegistro} item={item} Roll={'Admin'} />
								</td>
							</tr>
						)

					})}

				</MDBTableBody>
			</MDBTable>
		</div>
	)
}

export default VerEstados